import { ChecklistMetricStatus } from '../../handoff-checklist-v2/handoff-checklist-v2.types';
import { VoiceAirMetricDefinition } from '../voice-air-metrics.types';
import { getTenDlcRegistrationStatusQueryOptions } from '../voice-air-handoff.queries';
import { PhoneRegistrationStatus } from '@weave/schema-gen-ts/dist/schemas/tendlc/shared/v1/shared.pb';
import { getParsedErrorMessage } from 'redux/axios';
import { WEAVE_APP_URL } from 'apis/sso/sso-url-config';

export const tenDlcRegisteredMetric: VoiceAirMetricDefinition = {
  id: 'ten_dlc_registered',
  name: '10DLC Registered',
  isRequired: true,
  criteria: [
    {
      description: 'Location is 10DLC registered.',
      whereToFix: {
        label: '10DLC Settings',
        url: `${WEAVE_APP_URL}/home/dashboard#settings/organization/business-verification`,
      },
      evaluate: async (ctx) => {
        try {
          const queryOptions = getTenDlcRegistrationStatusQueryOptions(ctx.locationId);
          const resp = await ctx.queryClient.fetchQuery(
            queryOptions.queryKey,
            queryOptions.queryFn,
            {
              cacheTime: queryOptions.cacheTime,
              staleTime: queryOptions.staleTime,
            }
          );

          const statusDetails = resp?.defaultSmsStatusDetails;
          if (!statusDetails) {
            return {
              status: ChecklistMetricStatus.BLOCKED,
              reason: 'ten_dlc_no_registration',
              message: 'Failed to retrieve 10DLC registration status.',
            };
          }

          if (
            statusDetails.registered &&
            statusDetails.status ===
              PhoneRegistrationStatus.PHONE_REGISTRATION_STATUS_REGISTERED
          ) {
            return {
              status: ChecklistMetricStatus.PASSED,
              reason: 'ten_dlc_registration_verified',
              message: '10DLC registration is fully verified.',
            };
          }

          // Check if it is in-progress / pending / registerable
          const isPending = [
            PhoneRegistrationStatus.PHONE_REGISTRATION_STATUS_PENDING,
            PhoneRegistrationStatus.PHONE_REGISTRATION_STATUS_IN_PROGRESS,
            PhoneRegistrationStatus.PHONE_REGISTRATION_STATUS_REGISTERABLE_QUICKLY,
            PhoneRegistrationStatus.PHONE_REGISTRATION_STATUS_REGISTERABLE_SLOWLY,
          ].includes(statusDetails.status);

          if (isPending) {
            return {
              status: ChecklistMetricStatus.WARNING,
              reason: 'ten_dlc_registration_pending',
              message: `10DLC registration is currently pending or in progress: ${statusDetails.status}`,
            };
          }

          return {
            status: ChecklistMetricStatus.BLOCKED,
            reason: 'ten_dlc_unregistered',
            message: `Location 10DLC registration is not completed. Status: ${statusDetails.status}`,
          };
        } catch (err) {
          return {
            status: ChecklistMetricStatus.BLOCKED,
            reason: 'api_request_failed',
            message:
              getParsedErrorMessage(err) || 'Failed to verify 10DLC registration status.',
          };
        }
      },
    },
  ],
};
